/* eslint-disable consistent-return */

import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'

const styles = theme => ({
  previewBox: {
    backgroundColor: `var(--gameday-table-tablePreviewBgColor, ${theme.table.tablePreviewBgColor})`,
    border: `1px solid var(--gameday-table-tablePreviewBorderColor, ${theme.table.tablePreviewBorderColor})`,
  },
  previewOutline: {
    outline: `2px solid var(--gameday-table-tablePreviewOutline, ${theme.table.tablePreviewOutline})`,
  },
  previewColumn: {
    backgroundColor: `var(--gameday-table-tablePreviewColumns, ${theme.table.tablePreviewColumns})`,
  },
})

const PreviewBox = styled.div`
  position: fixed;
  border-radius: ${theme.borders.borderRadius};
  box-shadow: 2px 2px 5px 0 ${theme.newDropdown.shadowColor};
  right: 10px;
  bottom: 10px;
  z-index: 1;
`
const PreviewBounds = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(${props => props.visibleColumns}, 1fr);
  gap: 3px;
  width: calc(${props => props.visibleColumns} * 10px);
  height: 36px;
  margin: 8px;
`

const OutlineBox = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: ${props => props.percentVisible}%;
  left: ${props => props.offsetScroll}%;
  border-radius: 2px;
`

const Column = styled.div`
  display: block;
  border-radius: 2px;
`

const TablePreview = ({ classes, className, visibleColumns, visibleWidth, totalWidth, scrollPosition, ...props }) => {
  if (visibleWidth + 10 < totalWidth) {
    const percentVisible = Math.round((visibleWidth / totalWidth) * 100)
    const offsetScroll = Math.round((scrollPosition / totalWidth) * 100)
    return (
      <ThemeProvider theme={theme}>
        <PreviewBox className={cn(className, classes.previewBox)} {...props}>
          <PreviewBounds visibleColumns={visibleColumns}>
            <OutlineBox
              className={cn(classes.previewOutline)}
              percentVisible={percentVisible}
              offsetScroll={offsetScroll}
            />
            {Array.from({ length: visibleColumns }).map((_, index) => {
              // biome-ignore lint/suspicious/noArrayIndexKey: TODO
              return <Column className={cn(classes.previewColumn)} key={index} />
            })}
          </PreviewBounds>
        </PreviewBox>
      </ThemeProvider>
    )
  }
}

TablePreview.defaultProps = {
  visibleColumns: 0,
  visibleWidth: 0,
  totalWidth: 0,
  scrollPosition: 0,
}

const TablePreviewComponent = withStyles(styles)(TablePreview)
TablePreviewComponent.displayName = 'RowHeTablePreviewaderComponent'
export default TablePreviewComponent
